'use client';

import styled from 'styled-components';

export const StyledFooter = styled.footer`
  height: 40px;
  border-top: 1px solid var(--color-pale-gray);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 24px;

  .copylight {
    font-size: 12px;
    color: var(--color-footer-gray);
  }
`;
